<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="28" cy="28" r="28" fill="#2E48DA" />
    <path
      d="M37.4274 18.5783C36.9274 18.0673 36.1874 17.8783 35.4974 18.0783L19.4074 22.7273C18.6794 22.9293 18.1634 23.5063 18.0244 24.2383C17.8824 24.9843 18.3784 25.9323 19.0264 26.3283L24.0574 29.4003C24.5734 29.7163 25.2394 29.6373 25.6664 29.2093L31.4274 23.4483C31.7174 23.1473 32.1974 23.1473 32.4874 23.4483C32.7774 23.7373 32.7774 24.2083 32.4874 24.5083L26.7164 30.2693C26.2884 30.6973 26.2084 31.3613 26.5234 31.8783L29.5974 36.9283C29.9574 37.5273 30.5774 37.8683 31.2574 37.8683C31.3374 37.8683 31.4274 37.8683 31.5074 37.8573C32.2874 37.7583 32.9074 37.2273 33.1374 36.4773L37.9074 20.5083C38.1174 19.8283 37.9274 19.0883 37.4274 18.5783Z"
      fill="white"
    />
    <path
      opacity="0.4"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.0105 32.8074C18.8185 32.8074 18.6265 32.7344 18.4805 32.5874C18.1875 32.2944 18.1875 31.8204 18.4805 31.5274L19.8455 30.1614C20.1385 29.8694 20.6135 29.8694 20.9065 30.1614C21.1985 30.4544 21.1985 30.9294 20.9065 31.2224L19.5405 32.5874C19.3945 32.7344 19.2025 32.8074 19.0105 32.8074ZM22.7717 33.9998C22.5797 33.9998 22.3877 33.9268 22.2417 33.7798C21.9487 33.4868 21.9487 33.0128 22.2417 32.7198L23.6067 31.3538C23.8997 31.0618 24.3747 31.0618 24.6677 31.3538C24.9597 31.6468 24.9597 32.1218 24.6677 32.4148L23.3017 33.7798C23.1557 33.9268 22.9637 33.9998 22.7717 33.9998ZM23.0254 37.5678C23.1714 37.7148 23.3634 37.7878 23.5554 37.7878C23.7474 37.7878 23.9394 37.7148 24.0854 37.5678L25.4514 36.2028C25.7434 35.9098 25.7434 35.4348 25.4514 35.1418C25.1584 34.8498 24.6834 34.8498 24.3904 35.1418L23.0254 36.5078C22.7324 36.8008 22.7324 37.2748 23.0254 37.5678Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "56"
    },
    height: {
      type: String,
      default: "56"
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/icons/dashboard/figureIcon.vue